/* ==========================================================================
   YUSSEF MESSA — motor de animacion (GSAP + ScrollTrigger)
   Todo se activa por atributos data-* que ponen las secciones, asi que
   este archivo sirve para cualquier plantilla sin tocarlo.
   ========================================================================== */
(function () {
  "use strict";

  if (!window.gsap) return;
  gsap.registerPlugin(ScrollTrigger);

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var motionOff = document.body.classList.contains("motion-off");
  var off = reduced || motionOff;

  function topbarH() {
    var t = document.querySelector(".topbar");
    return t ? Math.round(t.getBoundingClientRect().height) : 0;
  }

  /* ---------- helpers de texto ---------- */
  function splitWords(el, cls) {
    var text = el.textContent.trim();
    el.innerHTML = text
      .split(/\s+/)
      .map(function (w) {
        return '<span class="' + (cls || "w") + '">' + w + "</span>";
      })
      .join(" ");
    return el.querySelectorAll("." + (cls || "w"));
  }

  function splitLines(el) {
    var html = el.innerHTML.split(/<br\s*\/?>/i);
    el.innerHTML = html
      .map(function (l) {
        return '<span class="split-line"><span>' + l.trim() + "</span></span>";
      })
      .join("");
    return el.querySelectorAll(".split-line > span");
  }

  /* ---------- revelados genericos ---------- */
  function reveals() {
    gsap.utils.toArray("[data-reveal]").forEach(function (el) {
      var d = parseFloat(el.dataset.delay || 0);
      gsap.from(el, {
        y: off ? 0 : 46,
        opacity: 0,
        duration: off ? 0.2 : 1.05,
        delay: d,
        ease: "power3.out",
        scrollTrigger: { trigger: el, start: "top 88%", once: true }
      });
    });

    gsap.utils.toArray("[data-split]").forEach(function (el) {
      var lines = splitLines(el);
      gsap.from(lines, {
        yPercent: off ? 0 : 118,
        opacity: off ? 0 : 1,
        duration: 1.15,
        stagger: 0.09,
        ease: "power4.out",
        scrollTrigger: { trigger: el, start: "top 86%", once: true }
      });
    });

    gsap.utils.toArray("[data-rule]").forEach(function (el) {
      gsap.from(el, {
        scaleX: 0,
        duration: 1.3,
        ease: "power3.inOut",
        scrollTrigger: { trigger: el, start: "top 94%", once: true }
      });
    });

    if (document.querySelector("[data-card]")) {
      ScrollTrigger.batch("[data-card]", {
        start: "top 90%",
        once: true,
        onEnter: function (batch) {
          gsap.to(batch, { y: 0, opacity: 1, duration: 1, stagger: 0.09, ease: "power3.out", overwrite: true });
        }
      });
      gsap.set("[data-card]", { y: off ? 0 : 60, opacity: off ? 1 : 0 });
    }
  }

  /* ---------- parallax ---------- */
  function parallax() {
    if (off) return;
    gsap.utils.toArray("[data-speed]").forEach(function (el) {
      var s = parseFloat(el.dataset.speed);
      gsap.to(el, {
        yPercent: -s * 100,
        ease: "none",
        scrollTrigger: { trigger: el, start: "top bottom", end: "bottom top", scrub: true }
      });
    });
  }

  /* ---------- bandas tipograficas ---------- */
  function marquees() {
    gsap.utils.toArray(".marquee").forEach(function (m) {
      var track = m.querySelector(".marquee__track");
      if (!track) return;
      var base = track.innerHTML;
      var dir = m.dataset.dir === "right" ? 1 : -1;
      var pxPerSec = parseFloat(m.dataset.speedPx || 58);
      var loop = null;

      // se reconstruye al cambiar el ancho o cargar las fuentes, para que la
      // cinta siempre sea mas del doble de la pantalla y no deje huecos
      function build() {
        if (loop) loop.kill();
        gsap.set(track, { x: 0 });
        track.innerHTML = base;
        var guard = 0;
        while (track.scrollWidth < window.innerWidth * 2.2 && guard++ < 16) {
          track.innerHTML += base;
        }
        var half = track.scrollWidth / 2;
        if (!half) return;
        loop = gsap.fromTo(
          track,
          { x: dir < 0 ? 0 : -half },
          { x: dir < 0 ? -half : 0, duration: half / pxPerSec, ease: "none", repeat: -1 }
        );
        if (off) loop.pause();
      }

      build();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
      var t;
      window.addEventListener("resize", function () {
        clearTimeout(t);
        t = setTimeout(build, 250);
      });

      if (off) return;

      // el scroll empuja la banda: acelera y vuelve a su ritmo
      ScrollTrigger.create({
        trigger: m,
        start: "top bottom",
        end: "bottom top",
        onUpdate: function (self) {
          if (!loop) return;
          var v = gsap.utils.clamp(0, 2.6, Math.abs(self.getVelocity()) / 900);
          gsap.to(loop, { timeScale: 1 + v, duration: 0.25, overwrite: true });
          gsap.to(loop, { timeScale: 1, duration: 1.2, delay: 0.3, overwrite: "auto" });
        }
      });
    });
  }

  /* ---------- cursor + botones magneticos ---------- */
  function pointer() {
    if (off || !window.matchMedia("(hover:hover) and (pointer:fine)").matches) return;
    var c = document.getElementById("ym-cursor");
    var d = document.getElementById("ym-cursor-dot");
    if (c && d) {
      var cx = gsap.quickTo(c, "x", { duration: 0.5, ease: "power3" });
      var cy = gsap.quickTo(c, "y", { duration: 0.5, ease: "power3" });
      var dx = gsap.quickTo(d, "x", { duration: 0.12, ease: "power3" });
      var dy = gsap.quickTo(d, "y", { duration: 0.12, ease: "power3" });
      window.addEventListener("mousemove", function (e) {
        cx(e.clientX); cy(e.clientY); dx(e.clientX); dy(e.clientY);
      });
      document.addEventListener("mouseover", function (e) {
        var hot = e.target.closest("a, button, .card, .panel, label");
        gsap.to(c, { scale: hot ? 1.9 : 1, opacity: hot ? 0.5 : 1, duration: 0.35, ease: "power2.out" });
      });
    }

    gsap.utils.toArray("[data-magnetic]").forEach(function (el) {
      var qx = gsap.quickTo(el, "x", { duration: 0.5, ease: "power3" });
      var qy = gsap.quickTo(el, "y", { duration: 0.5, ease: "power3" });
      el.addEventListener("mousemove", function (e) {
        var r = el.getBoundingClientRect();
        qx((e.clientX - r.left - r.width / 2) * 0.32);
        qy((e.clientY - r.top - r.height / 2) * 0.42);
      });
      el.addEventListener("mouseleave", function () { qx(0); qy(0); });
    });
  }

  /* ---------- contadores ---------- */
  function countTo(el, value) {
    var o = { v: parseFloat(el.dataset.from || 0) };
    gsap.to(o, {
      v: value,
      duration: 1.1,
      ease: "power2.out",
      onUpdate: function () { el.textContent = Math.round(o.v); }
    });
  }

  function counters() {
    gsap.utils.toArray("[data-count]").forEach(function (el) {
      var target = parseFloat(el.dataset.count);
      if (off) { el.textContent = Math.round(target); return; }
      ScrollTrigger.create({
        trigger: el, start: "top 88%", once: true,
        onEnter: function () { countTo(el, target); }
      });
    });
  }

  /* ---------- hero: intro + parallax ---------- */
  function heroIntro() {
    var hero = document.querySelector("[data-hero]");
    if (!hero) return null;
    var tl = gsap.timeline({ defaults: { ease: "power4.out" } });
    tl.from("[data-hero-eyebrow]", { y: 20, opacity: 0, duration: 0.8 }, 0)
      .from("[data-hero-title] .line > span", { yPercent: 115, duration: 1.25, stagger: 0.11 }, 0.05)
      .from("[data-hero-lead]", { y: 26, opacity: 0, duration: 1 }, 0.55)
      .from("[data-hero] .hero__meta .btn", { y: 24, opacity: 0, duration: 0.8, stagger: 0.08 }, 0.65)
      .from("[data-hero-mark]", { scale: 0.7, opacity: 0, rotate: -12, duration: 1.6, ease: "expo.out" }, 0.1)
      .from("[data-float-a]", { x: 140, y: -60, rotate: 22, opacity: 0, duration: 1.5, ease: "expo.out" }, 0.3)
      .from("[data-float-b]", { x: 120, y: 90, rotate: -16, opacity: 0, duration: 1.5, ease: "expo.out" }, 0.42)
      .from(".scroll-cue", { opacity: 0, duration: 0.8 }, 0.9)
      .from(".header__in > *", { y: -20, opacity: 0, duration: 0.7, stagger: 0.08 }, 0.2);

    gsap.to(".scroll-cue i", {
      backgroundColor: "rgba(232,112,47,.9)", duration: 1.1, repeat: -1, yoyo: true, ease: "sine.inOut"
    });
    return tl;
  }

  function heroScroll() {
    if (off || !document.querySelector("[data-hero]")) return;
    var st = { trigger: "[data-hero]", start: "top top", end: "bottom top" };
    gsap.to("[data-hero-title]", { yPercent: -18, opacity: 0.25, ease: "none", scrollTrigger: Object.assign({ scrub: 0.6 }, st) });
    gsap.to("[data-hero-mark]", { rotate: 26, scale: 1.35, ease: "none", scrollTrigger: Object.assign({ scrub: 1 }, st) });
    gsap.to("[data-float-a]", { y: -170, rotate: -14, ease: "none", scrollTrigger: Object.assign({ scrub: 0.8 }, st) });
    gsap.to("[data-float-b]", { y: -90, rotate: 10, ease: "none", scrollTrigger: Object.assign({ scrub: 1.2 }, st) });
  }

  /* ---------- preloader (solo la primera visita de la sesion) ---------- */
  function loaderStart(done) {
    var loader = document.getElementById("ym-loader");
    if (!loader) { done(); return; }

    var seen = false;
    try { seen = sessionStorage.getItem("ym-loaded") === "1"; } catch (e) {}
    if (off || seen) {
      loader.remove();
      document.body.classList.remove("is-locked");
      done();
      return;
    }
    try { sessionStorage.setItem("ym-loaded", "1"); } catch (e) {}

    var num = document.getElementById("ym-loader-num");
    document.body.classList.add("is-locked");
    var counter = { v: 0 };
    var tl = gsap.timeline();
    tl.to("#ym-loader-mark", { duration: 1.5, ease: "power2.inOut", webkitMaskPosition: "0% 0", maskPosition: "0% 0" }, 0)
      .to(counter, {
        v: 100, duration: 1.6, ease: "power2.inOut",
        onUpdate: function () { if (num) num.textContent = Math.round(counter.v); }
      }, 0)
      .to("#ym-loader-mark", { scale: 0.82, opacity: 0, duration: 0.7, ease: "power3.inOut" }, 1.7)
      .to("#ym-loader-num, .loader__word", { opacity: 0, duration: 0.5 }, 1.7)
      .to(loader, {
        yPercent: -100, duration: 1.05, ease: "expo.inOut",
        onComplete: function () {
          loader.remove();
          document.body.classList.remove("is-locked");
          ScrollTrigger.refresh();
        }
      }, 2.0)
      .add(function () { done(); }, 2.5);

    // seguro: si la pestaña estaba en segundo plano no dejamos la web bloqueada
    setTimeout(function () { if (tl.progress() < 1) tl.progress(1); }, 7000);
  }

  /* ---------- scroll horizontal clavado ---------- */
  function hscroll() {
    var hs = document.querySelector("[data-hscroll]");
    var track = hs && hs.querySelector("[data-hscroll-track]");
    if (!hs || !track) return;

    var mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", function () {
      if (motionOff) return;
      var distance = function () { return Math.max(0, track.scrollWidth - window.innerWidth); };
      var scrollTween = gsap.to(track, {
        x: function () { return -distance(); },
        ease: "none",
        scrollTrigger: {
          trigger: hs,
          pin: true,
          scrub: 0.8,
          start: function () { return "top " + topbarH() + "px"; },
          end: function () { return "+=" + distance(); },
          invalidateOnRefresh: true,
          anticipatePin: 1
        }
      });

      gsap.utils.toArray("[data-panel]").forEach(function (panel) {
        gsap.from(panel, {
          yPercent: 12, rotate: 2.5, opacity: 0, scale: 0.94, duration: 1, ease: "power3.out",
          scrollTrigger: {
            trigger: panel, containerAnimation: scrollTween,
            start: "left 92%", toggleActions: "play none none reverse"
          }
        });
        var img = panel.querySelector("[data-panel-img]");
        if (img) {
          gsap.fromTo(img, { rotate: -9, scale: 0.88 }, {
            rotate: 6, scale: 1.02, ease: "none",
            scrollTrigger: {
              trigger: panel, containerAnimation: scrollTween,
              start: "left right", end: "right left", scrub: true
            }
          });
        }
      });

      return function () {
        if (scrollTween.scrollTrigger) scrollTween.scrollTrigger.kill();
        gsap.set(track, { x: 0 });
      };
    });

    // sin animacion: el carrusel se desliza con el dedo
    mm.add("(prefers-reduced-motion: reduce)", function () {
      hs.style.overflowX = "auto";
      track.style.paddingBottom = "1rem";
    });
    if (motionOff) { hs.style.overflowX = "auto"; }
  }

  /* ---------- rotacion 360 ---------- */
  function rotate360() {
    var section = document.querySelector("[data-rotate]");
    var stage = section && section.querySelector("[data-rotate-stage]");
    if (!section || !stage) return;

    var frames = gsap.utils.toArray(stage.querySelectorAll("img"));
    if (!frames.length) return;
    var bar = section.querySelector("[data-rotate-bar]");
    var ring = section.querySelector("[data-rotate-ring]");

    function paint(p) {
      var pos = p * (frames.length - 1);
      frames.forEach(function (img, i) {
        gsap.set(img, { opacity: gsap.utils.clamp(0, 1, 1 - Math.abs(pos - i)) });
      });
    }
    paint(0);

    if (off) { paint(0.5); return; }

    ScrollTrigger.create({
      trigger: section,
      start: function () { return "top " + topbarH() + "px"; },
      end: "+=180%",
      pin: true,
      scrub: 0.7,
      invalidateOnRefresh: true,
      onUpdate: function (self) {
        var p = self.progress;
        paint(p);
        gsap.set(stage, { rotateY: -16 + p * 32, scale: 0.92 + p * 0.12 });
        if (ring) gsap.set(ring, { rotate: p * 320 });
        if (bar) gsap.set(bar, { scaleX: p });
      }
    });

    gsap.from(section.querySelectorAll(".rotate__copy > *"), {
      y: 30, opacity: 0, duration: 0.9, stagger: 0.09, ease: "power3.out",
      scrollTrigger: { trigger: section, start: "top 60%", once: true }
    });
    gsap.from(section.querySelectorAll(".rotate__spec li"), {
      x: 40, opacity: 0, duration: 0.8, stagger: 0.08, ease: "power3.out",
      scrollTrigger: { trigger: section, start: "top 55%", once: true }
    });
  }

  /* ---------- flip 3D ---------- */
  function flip3d() {
    var section = document.querySelector("[data-flip]");
    var card = section && section.querySelector("[data-flip-card]");
    if (!section || !card || off) return;
    var tag = section.querySelector("[data-flip-tag]");
    var labels = (tag && tag.dataset.labels ? tag.dataset.labels : "Delante|Detras").split("|");
    gsap.set(card, { rotateY: 0 });
    ScrollTrigger.create({
      trigger: section,
      start: "top 75%",
      end: "bottom 60%",
      scrub: 1,
      onUpdate: function (self) {
        var p = self.progress;
        gsap.set(card, {
          rotateY: p * 180,
          y: -30 * Math.sin(p * Math.PI),
          scale: 1 + 0.06 * Math.sin(p * Math.PI)
        });
        if (tag) tag.textContent = p > 0.5 ? labels[1] : labels[0];
      }
    });
  }

  /* ---------- manifiesto palabra a palabra ---------- */
  function manifesto() {
    var el = document.querySelector("[data-manifesto]");
    if (!el) return;
    var words = splitWords(el);
    var hl = (el.dataset.highlight || "")
      .toLowerCase()
      .split(",")
      .map(function (s) { return s.trim(); })
      .filter(Boolean);

    words.forEach(function (w) {
      var t = w.textContent.toLowerCase().replace(/[.,?!;:]/g, "");
      if (hl.indexOf(t) > -1) w.classList.add("hl");
    });

    if (off) {
      words.forEach(function (w) { w.classList.add("on"); });
      return;
    }
    ScrollTrigger.create({
      trigger: el,
      start: "top 80%",
      end: "bottom 55%",
      scrub: 0.4,
      onUpdate: function (self) {
        var n = Math.round(self.progress * words.length);
        words.forEach(function (w, i) { w.classList.toggle("on", i < n); });
      }
    });
  }

  /* ---------- entrada de paginas interiores ---------- */
  function pageIn() {
    if (off) return;
    var els = document.querySelectorAll("[data-page-in]");
    if (!els.length) return;
    gsap.timeline()
      .from(".header", { y: -80, opacity: 0, duration: 0.9, ease: "power3.out" })
      .from(els, { y: 40, opacity: 0, duration: 1, stagger: 0.08, ease: "power3.out" }, "-=.6");
  }

  /* ---------- arranque ---------- */
  function boot() {
    reveals();
    parallax();
    marquees();
    pointer();
    counters();
    hscroll();
    rotate360();
    flip3d();
    manifesto();
    heroScroll();

    var intro = heroIntro();
    if (intro) {
      intro.pause();
      loaderStart(function () { intro.play(); });
    } else {
      loaderStart(function () { pageIn(); });
    }

    window.addEventListener("load", function () { ScrollTrigger.refresh(); });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
    }
  }

  // API minima para que otros scripts reutilicen el motor
  window.YM_MOTION = { splitWords: splitWords, splitLines: splitLines, countTo: countTo, reduced: off };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
